import gql from "graphql-tag";

export const MY_TIMESHEET_TIMESHEET_LIST = gql`
  mutation listMysheetTimesheets(
    $contractId: String
    $startTime: Date
    $endTime: Date
    $page: Int
    $pageSize: Int
    $sort: String
    $sortDirection: String
    $searchText: String
    $searchField: String
    $periodStart: Date
    $periodEnd: Date
    $roleFilters: RoleFilterInput
    $typeFilters: TypeFilterInput
    $state: String
    $role: String
  ) {
    listMysheetTimesheets(
      contractId: $contractId
      startTime: $startTime
      endTime: $endTime
      page: $page
      pageSize: $pageSize
      sort: $sort
      sortDirection: $sortDirection
      searchText: $searchText
      searchField: $searchField
      periodStart: $periodStart
      periodEnd: $periodEnd
      roleFilters: $roleFilters
      typeFilters: $typeFilters
      state: $state
      role: $role
    ) {
      _id
      name
      description
      contractId
      startTime
      endTime
      validFrom
      validTo
      projectId
      projectName
      projectColor
      clientId
      clientName
      clientColor
      costId
      costName
      costColor
      cost
      costBillable
      createdAt
      createdBy
      modifiedAt
      modifiedBy
      state
      messageCount
    }
  }
`;
